import script from "./WordHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./WordHeader.vue?vue&type=script&setup=true&lang=js"

import "./WordHeader.vue?vue&type=style&index=0&id=96db33b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96db33b4"]])

export default __exports__